import React, { useState } from "react";
import styles from "./AgregarComentario.module.css";
import userIcon from "../../assets/iconUser.png";
import send from "../../assets/send.svg";

const AgregarComentario = ({
  mensaje,
  setMensaje,
  postComentario,
  valor,
  setValor,
  estrellasBool,
  style,
  error
}) => {
  const [hover, setHover] = useState(0);
  const user = JSON.parse(localStorage.getItem("dataUser"))
  console.log(user)
  const renderStars = () => {
    return [...Array(5)].map((_, index) => {
      const starValue = index + 1;
      return (
        <span
          key={index}
          className={`${styles.star} ${
            starValue <= (hover || valor) ? styles.activeStar : ""
          }`}
          onClick={() => setValor(starValue)}
          onMouseEnter={() => setHover(starValue)}
          onMouseLeave={() => setHover(0)}
        >
          ★
        </span>
      );
    });
  };

  return (
    <div className={styles.addComent} style={style}>
      <img src={user.foto || userIcon} alt="user" className={styles.foto} />
      <div className={styles.inputSection}>
        {estrellasBool && <div className={styles.estrellas}>{renderStars()}</div>}
        <input
          type="text"
          placeholder="Agregar comentario"
          className={styles.inputComent}
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
        />
        {error && <p className={styles.error}>{error}</p>}
      </div>
      <div className={styles.btnSend} onClick={postComentario}>
        <img src={send} alt="send" className={styles.sendIcon} />
      </div>
    </div>
  );
};

export default AgregarComentario;
